import { Card, styled, Typography, useMediaQuery, useTheme } from '@mui/material';
import type { FC } from 'react';

interface AvaniWelcomeBannerCardProps {
  name: string;
}

const AvaniStyledWelcomeBannerCard = styled(Card)(({ theme }) => ({
  [`& `]: {
    borderRadius: '16px',
    padding: '16px',
    backgroundImage: 'url("/static/images/background/welcomebanner-BGR.svg")',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    display: 'flex'
  },
  [`.MuiTypography-root.MuiTypography-h3 `]: {
    margin: 0,
    lineHeight: 1,
    display: 'block',
    float: 'left'
  }
}));

export const AvaniWelcomeBannerCard: FC<AvaniWelcomeBannerCardProps> = ({ name }) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'xl'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <AvaniStyledWelcomeBannerCard sx={{ flexDirection: isMobile ? 'column' : 'row', alignItems: 'center' }}>
      <Typography
        variant="h3"
        fontSize={isTablet ? 26 : isMobile ? 18 : 36}
        fontWeight={'bold'}
        lineHeight={'36px'}
        sx={{
          color: 'white',
          paddingTop: '12px',
          paddingLeft: isMobile ? '12px' : '38px',
          paddingRight: isMobile ? '12px' : '38px',
          flexGrow: 1
        }}
      >
        Welcome <span style={{ color: theme.colors.avani.lightTurc }}>{name}</span>
        <br /> to your <span style={{ color: theme.colors.avani.lightMagenta }}>Innsights Dashboard</span>
      </Typography>
      <img
        alt={'Avani Solutions'}
        width={isTablet ? '180' : isMobile ? '160' : '230'}
        src={'/static/images/logo/full_logo.png'}
        style={{ marginRight: !isMobile ? '38px' : 0, flexGrow: 0 }}
      />
    </AvaniStyledWelcomeBannerCard>
  );
};
